import { environment } from "src/environments/environment";
import { AuthConfig } from "./auth.config";

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.goAccessLoginUri,
  redirectUri: environment.redirectUri,
  clientId: environment.clientId,
  responseType: 'code',
  scope: environment.scope,
  showDebugInformation: true,
  timeoutFactor: parseFloat(environment.refreshTimeFactor),
  customQueryParams: { client_secret: environment.clientToken  },
  revocationEndpoint:environment.revocationEndpoint
};